var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { throttle, isArray, isObject, map, get, isEqual } from 'lodash';
import { default as AntSelect } from 'antd/lib/select';
import { basicPropTypes, controlPropTypes } from '../component-props';
import { services } from '@comall-backend-builder/core';

var SelectAutoComplete = function (_super) {
  __extends(SelectAutoComplete, _super);

  function SelectAutoComplete(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSearch = throttle(_this.handleSearch.bind(_this), 1000);
    return _this;
  }

  SelectAutoComplete.prototype.handleChange = function (value) {
    var _a = this.props,
        name = _a.name,
        onChange = _a.onChange;

    if (onChange) {
      var newValue = [];

      if (isArray(value)) {
        newValue = map(value, function (_a) {
          var key = _a.key,
              label = _a.label;
          return {
            id: key,
            name: label
          };
        });
      } else if (value !== null && value !== undefined) {
        newValue = {
          id: value.key,
          name: value.label
        };
      }

      onChange(newValue, name);
    }
  };

  SelectAutoComplete.prototype.handleSearch = function (value) {
    var _a;

    var _b = this.props,
        entity = _b.entity,
        name = _b.name,
        params = _b.params,
        fieldSource = _b.fieldSource,
        selectParamKey = _b.selectParamKey;

    if (!entity) {
      throw new Error("Componet SelectAutoComplete must have entity");
    }

    var source = get(entity, "metainfo." + fieldSource + "." + name.split('.').join('.properties.') + ".source");
    var method = fieldSource === 'properties' ? 'loadPropertyOptions' : 'loadFilterOptions';
    entity[method](name, source, __assign(__assign({}, params), (_a = {}, _a[selectParamKey] = value, _a)));
  };

  SelectAutoComplete.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  SelectAutoComplete.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        mode = _a.mode,
        name = _a.name,
        value = _a.value,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseSelect') : _b,
        disabled = _a.disabled,
        options = _a.options,
        allowClear = _a.allowClear,
        onSelect = _a.onSelect,
        onDeselect = _a.onDeselect;
    var antdValue = undefined;
    var selectProps = {
      // basicPropTypes
      className: className,
      style: style,
      // controlPropTypes
      mode: mode,
      name: name,
      placeholder: placeholder,
      disabled: disabled,
      allowClear: allowClear,
      labelInValue: true,
      showSearch: true,
      filterOption: false,
      onChange: this.handleChange,
      onSearch: this.handleSearch,
      onSelect: onSelect,
      onDeselect: onDeselect,
      value: antdValue
    };

    if (isArray(value)) {
      selectProps.value = value.map(function (_a) {
        var id = _a.id,
            name = _a.name;
        return {
          key: id,
          label: name
        };
      });
    } else if (isObject(value)) {
      selectProps.value = {
        key: value.id,
        label: value.name
      };
    } else {
      selectProps.value = undefined;
    }

    var children = map(options, function (_a) {
      var id = _a.id,
          name = _a.name;
      return React.createElement(AntSelect.Option, {
        key: id
      }, name);
    });
    return React.createElement(AntSelect, __assign({}, selectProps), children);
  };

  SelectAutoComplete.defaultProps = {
    fieldSource: 'properties',
    selectParamKey: 'name'
  };
  SelectAutoComplete.propTypes = __assign(__assign(__assign({}, basicPropTypes), controlPropTypes), {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fieldSource: PropTypes.oneOf(['properties', 'filters']),
    selectParamKey: PropTypes.string,
    // 待选项
    options: PropTypes.array.isRequired
  });
  return SelectAutoComplete;
}(Component);

export { SelectAutoComplete };